import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

const useResolvedLang = () => {
  const [lang, setLang] = useState<"en" | "hu">("en");

  const { i18n } = useTranslation();

  useEffect(() => {
    if (i18n.resolvedLanguage) {
      const l: string = i18n.resolvedLanguage;

      switch (l) {
        case "hu":
          setLang("hu");
          break;

        case "en":
          setLang("en");
          break;

        default:
          setLang("en");
          break;
      }
    }
  }, [i18n]);

  return lang;
};

export default useResolvedLang;
